// Mercapoli - Restaurant Orders (duplicate route handler)
import RestaurantDashboard from './Dashboard';
export default RestaurantDashboard;
